module.exports = __webpack_public_path__ + "img/DE05756.fda027df.png";